import {customElement, property, query} from "lit/decorators.js";
import {html, type TemplateResult} from "lit";
import {FormInputElement} from "./formInputElement";
import {InputElementType} from "../validations/validations";
import {spreadAttributes} from "../../../common/directives/spreadAttributes";
import type {Maybe} from "../../../bootstrap/common/types";

@customElement("eop-form-text-field")
export class EopFormTextField extends FormInputElement<string> {

    @property({attribute: "label"})
    public label: string;
    @property({attribute: "placeholder"})
    public placeholder: string;
    @query("input")
    private input: HTMLInputElement;

    public constructor() {
        super("");
        this.type = InputElementType.TEXT;
    }

    public render(): TemplateResult {
        return html`
            <label for=${this.formUUId} @click=${this.preventLabelDefaultAction}>
                <span class="label-text">${this.label}</span>
                ${this.labelSuffix()}
            </label>
            <div class="input-element ${this.basicClassMap()}">
                <input
                        id=${this.formUUId}
                        name=${this.getFullId()}
                        .value=${this.value}
                        ?filled=${this.value}
                        @change=${this.change}
                        @input=${this.onInput}
                        type=${this.type}
                        ?required=${this.required}
                        placeholder=${this.placeholder ?? ""}
                        ${spreadAttributes(this.customAttributes)}
                >
            </div>
            ${(this.renderValidationMessages())}
        `;
    }

    public focusInput(): void {
        this.input.focus();
    }

    protected preset(): Maybe<string> {
        return this.getAttribute("preset") ?? undefined;
    }

    private change(event: Event): void {
        this.updateValue((event.target as HTMLInputElement).value);
    }

    private onInput(event: Event): void {
        if (this.isValidatable) {
            this.updateValidState((event.target as HTMLInputElement).value);
        }
    }
}